import { h, render } from 'preact';
import ProductImage from './ProductImage';
import { Image } from '../types';

export default function(pictureElements: NodeListOf<HTMLDivElement>) {
    pictureElements.forEach(pictureElement => {
        const productName = pictureElement.dataset.name as string;
        const images = JSON.parse(pictureElement.dataset.images as string) as Array<Image>;
        const imagesFull = JSON.parse(pictureElement.dataset.imagesFull as string) as Array<Image>;
        // DEVTODO: Replace this with 1088px by 1192px images when they are available from the api
        const zoomed = imagesFull;
        let embeds = null as Array<Image> | null;
        if (pictureElement.dataset.embeds) {
            embeds = JSON.parse(pictureElement.dataset.embeds as string);
        }

        if (images.length === 0) {
            return;
        }

        const escapedName = pictureElement.dataset['name']?.replace("'", "\\'");
        const productImageContainer = document.querySelector("[data-name='" + escapedName  + "']") as HTMLDivElement;

        const productImage = h(
            ProductImage,
            { productName, images, zoomed, imagesFull, embeds, defaultColour: images[0].colour },
            null
        );

        productImageContainer.innerHTML = '';
        render(productImage, productImageContainer);
    })
}
